'use client'

import React from 'react';


const BrandSlider: React.FC<any> = ({ datas }) => {
    return (
        <div className={`border-t-slate-200 border-t-[1px] ${datas.brandsImages.length === 0 ? 'hidden' : ''}`}>
            <div className="container py-6 flex flex-col items-center gap-2">
                <h2 className="text-2xl md:text-3xl font-bold font-alt text-center">{datas.brandsTitle}</h2>
                <p className="text-sm md:text-md font-alt text-center">
                    {datas.brandsSubtitle}
                </p>
                <div className="overflow-x-hidden flex max-w-full relative before:content-[''] before:w-20 before:h-full before:bg-gradient-to-r before:from-white before:to-transparent before:absolute before:left-0 before:top-0 before:z-10 after:content-[''] after:w-20 after:h-full after:bg-gradient-to-l after:from-white after:to-transparent after:absolute after:right-0 after:top-0 after:z-10">
                    <ul className="flex items-center gap-10 text-white py-8 animate-infinite-scroll hover:paused">
                        {[...datas.brandsImages, ...datas.brandsImages].map((brand, index) => (
                            <li className="w-30 md:w-60 hover:scale-110 transition-all" key={index}>
                                <img src={brand.image?.s3Url} alt={brand.alt} className="w-full h-full object-contain" />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default BrandSlider;
